import {
  EnergyFuelType,
  EnergyPaymentMethod,
  EnergyQuote,
  EnergyQuoteDetails,
  EnergyQuoteType,
} from '@generated/gql/graphql';

export const hasPrepaymentMeter = (details: EnergyQuoteDetails) => {
  return (
    details.gasPaymentMethod === EnergyPaymentMethod.Prepayment ||
    details.electricityPaymentMethod === EnergyPaymentMethod.Prepayment
  );
};

export const getTariffEndDate = (quote: EnergyQuote) => {
  const { electricity, gas } = quote;

  if (electricity && electricity.quoteType === EnergyQuoteType.Fixed) {
    return electricity.tariffEndDate;
  }

  if (gas && gas.quoteType === EnergyQuoteType.Fixed) {
    return gas.tariffEndDate;
  }

  return null;
};

export const hasServices = (fuelType: EnergyFuelType) => {
  const hasElectricity = [
    EnergyFuelType.ElectricityOnly,
    EnergyFuelType.DualFuel,
  ].includes(fuelType);
  const hasGas = [EnergyFuelType.GasOnly, EnergyFuelType.DualFuel].includes(
    fuelType
  );

  return {
    hasElectricity,
    hasGas,
  };
};
